import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../store/actions/user";

const Logout = (props) => {
    let dispatch = useDispatch();
    useEffect(() => {
        dispatch(logoutUser({ user_id: props.user?.id }));
    }, []);

    return <div></div>;
};

export default Logout;